import { render } from "./Surge.vue?vue&type=template&id=247a1836&ts=true"
import script from "./Surge.vue?vue&type=script&lang=ts"
export * from "./Surge.vue?vue&type=script&lang=ts"

import "./Surge.vue?vue&type=style&index=0&id=247a1836&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__